import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography
} from '@material-ui/core'

import React from 'react'
import SearchScheduleTranslationText from 'src/views/vesselschedule/searchschedule/SearchScheduleTranslationText'
import CheckboxGroup from 'src/views/freightbooking/components/CheckboxGroup'
const ForwardHubFilterComponents = (props) => {
  const translatedTextsObject = SearchScheduleTranslationText()

  return (
    <Grid container='true' container item class={'rs-filter-card'}>
      <Grid class={'rs-bg-grey'}>
        <Typography class={'rs-filter-subheader'}>
          forward hub scheme
        </Typography>
      </Grid>
      <Grid>
        <CheckboxGroup
          checkBoxList={props.forwardHubList}
          onChange={props.onCarrierCheckBoxChange}
          filterName={"Carrier"} />
      </Grid>
    </Grid>
  )
}



export default ForwardHubFilterComponents
